import {GOOGLE_CONFIG} from '../../config'
import {useEffect, useState} from 'react'

export const useAppzi = () => {
    const [, setLoadApp] = useState(false)
    const existingScript = document.getElementById('googleMaps')
    const pathName = window.location.pathname

    useEffect(()=>{
        if (pathName !== '/login') {
            if (!existingScript) {
                const script = document.createElement('script')
                script.src = GOOGLE_CONFIG.FEEDBACK_URL
                document.body.appendChild(script)
                script.onload = () => {
                    setLoadApp(true)
                }
            }else{
                setLoadApp(true)
            }
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])
}